<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <h1>ФИЛТРИ КЪМ СПРАВКАТА</h1>
        <span class="mck modal-close" @click="close()">F</span>
      </div>
      <div class="modal-content">
        <p>
          <strong>ВКЛЮЧЕНИ РАЗХОДИ ЗА:</strong>
        </p>
        <label class="checkbox-wrapper">
          СОБСТВЕНА МЕХАНИЗАЦИЯ
          <input type="checkbox" v-model="mechanization" />
          <span class="checkmark"></span>
        </label>
        <label class="checkbox-wrapper">
          НАЕТА МЕХАНИЗАЦИЯ
          <input type="checkbox" v-model="rentedMechanization" />
          <span class="checkmark"></span>
        </label>
        <label class="checkbox-wrapper">
          МАТЕРИАЛИ
          <input type="checkbox" v-model="materials" />
          <span class="checkmark"></span>
        </label>
        <label class="checkbox-wrapper">
          ТРУД
          <input type="checkbox" v-model="workers" />
          <span class="checkmark"></span>
        </label>
        <br />
        <p>
          <strong>ТИП ОТЧЕТИ:</strong>
        </p>
        <label class="checkbox-wrapper">
          ПЛАНИРАНИ ОТЧЕТИ
          <input type="checkbox" v-model="planned" />
          <span class="checkmark"></span>
        </label>
        <label class="checkbox-wrapper">
          ГРЕШНИ ОТЧЕТИ
          <input type="checkbox" v-model="invalid" />
          <span class="checkmark"></span>
        </label>
        <label class="checkbox-wrapper">
          ПОКАЖИ САМО САМООТЧЕТИ
          <input
            type="checkbox"
            :checked="confirmedSelfReports === 'all'"
            :disabled="confirmedSelfReports === 'all'"
            @change="setFilter('all')"
          />
          <span class="checkmark"></span>
        </label>
        <label class="checkbox-wrapper">
          ПОКАЖИ САМО ПРИЕТИ САМООТЧЕТИ
          <input
            type="checkbox"
            :checked="confirmedSelfReports === true"
            :disabled="confirmedSelfReports === true"
            @change="setFilter(true)"
          />
          <span class="checkmark"></span>
        </label>
        <label class="checkbox-wrapper">
          ПОКАЖИ САМО НЕПРИЕТИ САМООТЧЕТИ
          <input
            type="checkbox"
            :checked="confirmedSelfReports === false"
            :disabled="confirmedSelfReports === false"
            @change="setFilter(false)"
          />
          <span class="checkmark"></span>
        </label>
        <br />
        <p>
          <strong>ПОКАЖИ:</strong>
        </p>
        <label class="checkbox-wrapper">
          АКТИВНИ ОБЕКТИ
          <input type="checkbox" v-model="active" />
          <span class="checkmark"></span>
        </label>
        <label
          title="Изберете, за да виждате всички проекти - и Вътрешни и Външни"
          class="checkbox-wrapper"
          v-if="$route.name !== 'ExternalInquiry'"
        >
          ВСИЧКИ ПРОЕКТИ (ВЪНШНИ + ВЪТРЕШНИ)
          <input type="checkbox" v-model="externalProjects" />
          <span class="checkmark"></span>
        </label>
        <label
          title="Изберете, за да виждате само служители, маркирани като Външни"
          class="checkbox-wrapper"
        >
          САМО ВЪНШНИ РАБОТНИЦИ
          <input type="checkbox" v-model="externalWorkers" />
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="modal-footer">
        <button class="btn btn-new" @click="save()">
          <span class="mck">Y</span>
          <template>Запис</template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "activeProjects",
    "isInvalid",
    "isPlanned",
    "showMechanizations",
    "showRentedMechanizations",
    "showWorkers",
    "showMaterials",
    "showExternalProjects",
    "showExternalWorkers",
    "isSelfReportConfirmed",
  ],
  data() {
    return {
      active: this.activeProjects || false,
      externalProjects: this.showExternalProjects || false,
      externalWorkers: this.showExternalWorkers || false,
      invalid: this.isInvalid || false,
      planned: this.isPlanned || false,
      mechanization: this.showMechanizations || false,
      rentedMechanization: this.showRentedMechanizations || false,
      workers: this.showWorkers || false,
      materials: this.showMaterials || false,
      confirmedSelfReports:
        this.isSelfReportConfirmed !== undefined
          ? this.isSelfReportConfirmed
          : undefined,
    };
  },
  methods: {
    setFilter(value) {
      this.confirmedSelfReports = value;
    },
    save() {
      const output = {
        activeProjects: this.active,
        isInvalid: this.invalid,
        isPlanned: this.planned,
        showMechanizations: this.mechanization,
        showRentedMechanizations: this.rentedMechanization,
        showWorkers: this.workers,
        showMaterials: this.materials,
        showExternalProjects: this.externalProjects,
        showExternalWorkers: this.externalWorkers,
        isSelfReportConfirmed: this.confirmedSelfReports,
      };
      this.$emit("save", output);
    },
    close() {
      this.$emit("close");
    },
    handleEvents(e) {
      if (e.code === "Enter") {
        this.save();
      } else if (e.code === "Escape") {
        this.close();
      }
    },
  },
  mounted() {
    if (this.selected) {
      this.date = this.selected;
    } else {
      this.date = new Date();
    }
    window.addEventListener("keydown", this.handleEvents);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEvents);
  },
};
</script>

<style scoped>
.modal {
  width: initial;
}
.modal-header {
  background-color: #fff;
  justify-content: space-between;
  height: initial;
  flex-direction: row;
  padding: 5px 5px 5px 15px;
}
.modal-header h1 {
  color: #000;
  font-size: 11px;
}
.modal-content {
  padding-left: 15px;
  padding-right: 15px;
}
.modal-footer {
  background-color: transparent;
  justify-content: center;
}
.modal-close {
  margin-left: 10px;
  position: static;
}
.btn {
  margin: 0;
}
.checkbox-wrapper {
  margin: 5px 0;
}
.checkbox-wrapper input:checked ~ .checkmark {
  background-color: #000;
}
.checkbox-wrapper:hover input:checked ~ .checkmark {
  background-color: rgba(0, 0, 0, 0.8);
}
/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 80vh;
    width: 90%;
  }
  .modal-header .new-input {
    width: 72%;
  }
}
@media screen and (max-width: 600px) {
  .modal-content-check {
    width: 45%;
  }
  .modal-footer {
    flex-direction: column;
    height: 97px;
  }
  .select-btns {
    margin: 10px 0;
  }
  .btn.btn-new {
    margin: 0 0 10px 0;
  }
}
@media screen and (max-width: 400px) {
  .modal-content-check {
    width: 100%;
  }
}
</style>
